import styled from "styled-components";

export const Image = styled.img`
    position: absolute;
    z-index: 0;
    width: 120%;
    margin: auto 0;
    bottom: 0px;
`;
